import CityPageTemplate from "../city-template/CityPageTemplate";
import { longmontConfig } from "./data";

export default function LongmontPage() {
  return <CityPageTemplate config={longmontConfig} />;
}